import * as React from 'react';
import { Validation } from '../utils/Validation';
import { Input } from './Input';

interface PasswordInputProps {
  validation: Validation;
  onChange: (password: string, check: boolean) => void;
}

/**
 * 確認欄が入力されていて、パスワードと一致しないときだけ不一致のメッセージを返す。
 * 確認欄が空のうちは、まだ入力の途中なのでメッセージを出さない。
 */
function getMismatchMessage(password: string, checkPassword: string): string | undefined {
  if (checkPassword === '') {
    return undefined;
  }
  if (password === checkPassword) {
    return undefined;
  }
  return 'パスワードが一致しません';
}

export const PasswordInput: React.FC<PasswordInputProps> = function (props) {
  const [password, setPassword] = props.validation.useState('password', '');
  const [checkPassword, setCheckPassword] = React.useState<string>('');

  const check = password === checkPassword;

  // 呼び出し側の状態を描画の途中で変えないよう、入力が変わった後に呼び出し側へ知らせる。
  // onChangeは描画のたびに作り直されるので、最新の関数をrefに保持して、入力が変わったときだけ呼ぶ
  const onChangeRef = React.useRef(props.onChange);
  onChangeRef.current = props.onChange;
  React.useEffect(() => {
    onChangeRef.current(password, check);
  }, [password, check]);

  return (
    <div className="PasswordInput-container">
      <Input
        label="パスワード"
        className="PasswordInput-password_input"
        type="password"
        required={true}
        onChange={(event) => {
          const password = event.target.value;
          setPassword(password);
        }}
        value={password}
        validationMessage={props.validation.get('password')}
      />
      <Input
        label="パスワード（確認用）"
        className="PasswordInput-password_input"
        type="password"
        required={true}
        onChange={(event) => {
          const checkPassword = event.target.value;
          setCheckPassword(checkPassword);
        }}
        value={checkPassword}
        validationMessage={getMismatchMessage(password, checkPassword)}
      />
    </div>
  );
};
